// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createTask_shadow{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.createTask_popup{
    background: #FFFFFF;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.103611);
    border-radius: 24px;
    height: 100%;
    width: 100%;
    max-width: 374px;
    max-height: 500px;
    padding: 26px;

    display: flex;
    flex-direction: column;
    gap: 11px;
}

.createTask_header{
    display: flex;
    justify-content: space-between;
}

.createTask_title{
    font-weight: 700;
    font-size: 14px;
    line-height: 23px;
    letter-spacing: 0.3px;
    color: #121212;
}

.createTask_close{

}

.createTask_input{
    font-family: inherit;
    font-size: inherit;
    display: block;
    width: 323px;
    height: 279px;

    background: #FFFFFF;
    border: 1px solid #CECECE;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.1);
    border-radius: 24px;
    padding: 12px;
}

.createTask_tags{
    display: flex;
}

.createTask_tags_icon{

}

.createTask_tags_list{

}

.createTask_tags_add{

}

.createTask_buttons{
    display: flex;
    flex-direction: column;
    gap: 11px;
}

.createTask_button{
    width: 100%;
    height: 40px;
    border-radius: 24px;

    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    letter-spacing: 0.1px;

    color: #FFFFFF;
    border: 1px solid #0000;
    background: #fff;
}

.createTask_save{
    background: #FFA825;
}

.createTask_draft{
    border-color: #CAC4D0;
    color: #CAC4D0;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/createTaskPopup/CreateTaskPopup.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sDAAsD;IACtD,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;;IAEb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;AAEA;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;;IAEb,mBAAmB;IACnB,yBAAyB;IACzB,iDAAiD;IACjD,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;;IAErB,cAAc;IACd,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":[".createTask_shadow{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.createTask_popup{\n    background: #FFFFFF;\n    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.103611);\n    border-radius: 24px;\n    height: 100%;\n    width: 100%;\n    max-width: 374px;\n    max-height: 500px;\n    padding: 26px;\n\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n}\n\n.createTask_header{\n    display: flex;\n    justify-content: space-between;\n}\n\n.createTask_title{\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 23px;\n    letter-spacing: 0.3px;\n    color: #121212;\n}\n\n.createTask_close{\n\n}\n\n.createTask_input{\n    font-family: inherit;\n    font-size: inherit;\n    display: block;\n    width: 323px;\n    height: 279px;\n\n    background: #FFFFFF;\n    border: 1px solid #CECECE;\n    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.1);\n    border-radius: 24px;\n    padding: 12px;\n}\n\n.createTask_tags{\n    display: flex;\n}\n\n.createTask_tags_icon{\n\n}\n\n.createTask_tags_list{\n\n}\n\n.createTask_tags_add{\n\n}\n\n.createTask_buttons{\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n}\n\n.createTask_button{\n    width: 100%;\n    height: 40px;\n    border-radius: 24px;\n\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    letter-spacing: 0.1px;\n\n    color: #FFFFFF;\n    border: 1px solid #0000;\n    background: #fff;\n}\n\n.createTask_save{\n    background: #FFA825;\n}\n\n.createTask_draft{\n    border-color: #CAC4D0;\n    color: #CAC4D0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
